import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { rewriteLegacyAppUrl } from '../legacy-route-url.util';

/**
 * Redirects legacy feature URLs to their unified paths (e.g. `/my-agents` → `/ai-agents`).
 */
export const legacyFeatureRedirectGuard: CanActivateFn = (_route, state) => {
    const router = inject(Router);
    const rewritten = rewriteLegacyAppUrl(state.url);

    if (rewritten === state.url) {
        return true;
    }

    return router.parseUrl(rewritten);
};
